// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__1d77J","lastUpdated":"TermsOfService_lastUpdated__2zk34"};